module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/record-create-source.8e5de187.png";